"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classnames = _interopRequireDefault(require("classnames"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var IdeationListItem = function IdeationListItem(_ref) {
  var className = _ref.className,
      name = _ref.name,
      selectedName = _ref.selectedName,
      onSelect = _ref.onSelect;
  return (0, _preact.h)("li", {
    className: className
  }, (0, _preact.h)("div", {
    onClick: function onClick() {
      return onSelect(name);
    },
    onKeyUp: function onKeyUp(e) {
      return e.code === 'Enter' ? onSelect(name) : null;
    },
    className: (0, _classnames.default)('list-item-button', {
      selected: selectedName === name
    }),
    role: "button",
    tabIndex: 0
  }, (0, _preact.h)("div", {
    className: "vertical-line"
  }), name === null ? (0, _preact.h)(_phrase.default, {
    p: "all.statuses"
  }) : (0, _preact.h)("span", null, name)));
};

var _default = IdeationListItem;
exports.default = _default;